'use client';

import { PageRow } from '@components/PageRow';
import { GridItem } from '@coolblue-development/freddy';
import { MediaGallery } from '@coolblue-development/next-patterns/client';
import { ImageGalleryBlock } from '@sharedTypes';

type Props = {
  block: ImageGalleryBlock;
};

// TODO: This custom styling of the max height causes the images to look blurry. This value isn't the value that is used to determine the src used for the image
// Will solve this later since the next-patterns library is updated and the MediaGallery will come from the server folder or the client/Image folder
export const ImageGallery = ({ block }: Props) => {
  return (
    <PageRow backgroundColor='base'>
      <GridItem
        column={2}
        sx={theme => ({
          // Entire Media Gallery
          '> div > div': {
            // Media Gallery
            '> div:nth-of-type(1)': {
              margin: '0 -2.4rem',
              'ul li > div': {
                height: '100%',
                img: {
                  objectFit: 'cover',
                  maxHeight: '422px',
                  [theme.breakpoint.minWidth('md')]: {
                    maxHeight: '703px'
                  }
                }
              },
              [theme.breakpoint.minWidth('lg')]: {
                // Arrow buttons
                'button div': {
                  padding: '1.6rem'
                }
              }
            },
            // Thumbnail bar
            '> div:nth-of-type(2)': {
              justifyContent: 'center'
            }
          }
        })}
      >
        <MediaGallery
          maxThumbnailItems={{ xs: 5, md: 8 }}
          zoom='none'
          openModalOnClick={false}
          variant='full'
          overlayTitle=''
          imageFit='cover'
          mediaGalleryItems={block.images}
        />
      </GridItem>
    </PageRow>
  );
};
